export default {
	editEventDate: "Editar data de entrada ou saída",
	becomeMedium: "Tornar Médium",
	leaveMedium: "Desligar Médium",
	becomeMediumTitle: "Tornar Médium",
	leaveMediumTitle: "Desligar da Corrente",
	becomeMediumConfirm: "Confirmar entrada na corrente",
	leaveMediumConfirm: "Confirmar saída da corrente",
	entryEvent: "Entrada na Corrente",
	exitEvent: "Saída da Corrente",
	date: "Data",
	reason: "Motivo",
	notes: "Observações",
	entryDate: "Data de entrada na corrente",
	entryNotes: "Observações da entrada",
	personSource: {
		existing: "Já cadastrada",
		new: "Cadastrar nova",
	},
	reasons: {
		voluntary: "Afastamento voluntário",
		disciplinary: "Afastamento disciplinar",
		transfer: "Mudança de terreiro",
		other: "Outros",
	},
	leaveMediumWarning: "Esta ação também desativará todas as jornadas ativas desta pessoa.",
	success: {
		entry: "Pessoa agora é médium da corrente",
		exit: "Pessoa desligada da corrente",
	},
	timeline: {
		title: "Histórico",
		empty: "Nenhum registro encontrado",
		by: "por",
	},
};
